var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"user-menu__stats-item align-center",class:_vm.textColor,attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"user-menu__stats-number",attrs:{"md12":"","xs6":""}},[_vm._v(_vm._s(_vm.number))]),_c('v-flex',{staticClass:"user-menu__stats-text",attrs:{"md12":"","xs6":""}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }